import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toggleForceFS } from "store/application/application-action";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "hooks/useDeviceType";
import { useExperiments } from "hooks/useExperiments";
import { loadFirstPageUrl, setFirstPageUrl } from "utils/storage";

const WATCH_PATH = "/watch";

export const useWatchPageTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const { fsmenu } = useExperiments();

  useEffect(() => {
    if (!fsmenu) {
      return;
    }

    const firstPageURL = loadFirstPageUrl();
    const onWatchPage = location.pathname.includes(WATCH_PATH);

    if (!firstPageURL) {
      const isForceFS = !isDesktop && onWatchPage;
      setFirstPageUrl(location.pathname);
      dispatch(toggleForceFS(isForceFS));
    } else if (onWatchPage && firstPageURL?.includes(WATCH_PATH)) {
      setFirstPageUrl("/");
      dispatch(toggleForceFS(false));
    }
  }, [location, isDesktop, fsmenu, dispatch]);
};
